import React from 'react';
import CustomCheckbox from '../../../../../shared/CustomCheckbox/CustomCheckbox';
import CustomSwitch from '../../../../../shared/CustomSwitch/CustomSwitch';

function AccountInformation({
  checked,
  onChange,
  hidden,
  additionalChecked,
  onAdditionalChange,
}) {
  return (
    <div
      className={`garden-wall-normal-card my-account-card ${hidden ? 'card-disabled' : ''}`}
    >
      {/* Account Information Header */}
      <div className="title-row">
        <div className="section-title-my-account">Account Information</div>
        <CustomSwitch
          checked={checked}
          onChange={onChange}
          size="small"
          color="var(--primary-color)"
        />
      </div>

      {/* Name */}
      <div className="my-account-section-row">
        <div className="section-label">Name</div>
        <div className="section-value">Herman Hoff</div>
      </div>
      <div className="divider"></div>

      {/* Email */}
      <div className="my-account-section-row">
        <div className="section-label">Email</div>
        <div className="section-value">joy1103@yahoo.com</div>
      </div>
      <div className="divider"></div>

      {/* Additional Contact Information Header */}
      <div className="title-row">
        <div className="section-title-my-account">
          Additional Contact Information
        </div>
        <CustomSwitch
          checked={additionalChecked}
          onChange={onAdditionalChange}
          size="small"
          color="var(--primary-color)"
        />
      </div>

      {/* Additional Contact Section - Dimmed when switch is OFF */}
      <div
        className={`additional-contact-section ${!additionalChecked ? 'section-disabled' : ''}`}
      >
        <div className="my-account-section-row">
          <div className="section-label">Contact 1 (Email)</div>
          <div className="section-value">
            <div>harithawork24@gmail.com</div>
            <div style={{ margin: '20px 0' }}>
              <CustomCheckbox label="Allow Marketing" />
            </div>
            <div>
              <CustomCheckbox label="Text Preferred" />
            </div>
          </div>
        </div>
        <div className="divider"></div>
      </div>

      {/* Delivery Address */}
      <div className="my-account-section-row">
        <div className="section-label">Delivery address</div>
        <div className="section-value">
          Herman Hoff, 302 TEAKWOOD DR 294889529 SC
        </div>
      </div>
    </div>
  );
}

export default AccountInformation;
